@if (loading()) {
<div class="card card-details shadow-sm p-3 mb-3">
  <div
    class="d-flex justify-content-between align-items-start flex-wrap gap-2 details-header-skeleton"
  >
    <div class="d-flex align-items-center gap-3">
      <button
        class="btn btn-sm btn-falcon-default btn-back"
        type="button"
        disabled
        aria-hidden="true"
      >
        <span class="fas fa-arrow-left"></span>
      </button>

      <div class="d-flex flex-column placeholder-glow">
        <span class="placeholder rounded skel-title d-block"></span>
        <span class="placeholder rounded skel-subtitle d-block"></span>
      </div>
    </div>
  </div>
</div>
} @else {
<div class="card card-details shadow-sm p-3 mb-3">
  <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
    <div class="d-flex align-items-center gap-3">
      <button
        class="btn btn-sm btn-falcon-default btn-back"
        type="button"
        (click)="back.emit()"
        [title]="'admin.common.back' | translate"
      >
        <span class="fas fa-arrow-left"></span>
      </button>

      <div class="d-flex flex-column">
        <span class="fs-8 fw-semibold text-gray-900">{{ title() || "-" }}</span>

        @if (subtitle(); as subtitle) {
        <small class="fw-normal text-gray-900" style="font-size: 12px">{{
          subtitle
        }}</small>
        } @if (id(); as id) {
        <small
          class="fw-normal text-gray-900 d-flex align-items-center"
          style="font-size: 11px"
        >
          ID: {{ id }}
          <button
            type="button"
            class="btn btn-link p-0 ms-2 d-inline-flex align-items-center"
            style="line-height: 1"
            aria-label="Copy ID"
            (click)="onCopyId($event)"
          >
            <i class="fas fa-copy" style="font-size: 11px"></i>
          </button>
        </small>
        }
      </div>
    </div>

    <div class="d-flex flex-wrap gap-2 justify-content-end mt-2 mt-sm-0">
      <ng-content></ng-content>
    </div>
  </div>
</div>
}
